/**
 * The Board keeps per-day working state in localStorage under `oc-<name>-<YYYY-MM-DD>`: in-time
 * annotations, relief assignments, room and nurse transfers, float CRNAs, case markers, the move
 * log and undo stack. Those values name real providers and record who is where on a given day.
 *
 * localStorage outlives a sign-out, so on a shared workstation the next person to use the browser —
 * possibly from another tenant — would inherit them. Clearing every dated board key at sign-out
 * keeps one user's working notes about named staff from being left behind for the next.
 *
 * Undated preferences (`oc-theme`, `oc-board-algorithm`, `oc-board-bullpen-open`, the selected
 * date) carry nothing about a person and are left alone, so signing out does not reset the UI.
 * Same key convention `clearAllDayOverlays` (components/boardViewHelpers.ts) sweeps for one date.
 */

const DATED_BOARD_KEY = /^oc-.+-\d{4}-\d{2}-\d{2}$/;

export const clearBoardWorkingState = (
  store: Pick<Storage, 'key' | 'length' | 'removeItem'> = localStorage,
): void => {
  const keys: string[] = [];
  for (let i = 0; i < store.length; i++) {
    const k = store.key(i);
    if (k && DATED_BOARD_KEY.test(k)) keys.push(k);
  }
  for (const k of keys) { try { store.removeItem(k); } catch { /* best-effort */ } }
};
